<template>
  <div :class="{ 'delivery-display': deliveryDisplay }">
    <!-- 标签编号编辑 -->
    <el-dialog :title="$t('message.labelNumberEditing')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="780px" center>
      <div class="content">
        <div class="tabs">
          <el-tabs v-model="datas.type" type="card" @tab-click="handleClick">
            <el-tab-pane v-for="item in tagList" :label="item.remark" :name="item.type" :key="item.type"></el-tab-pane>

          </el-tabs>
        </div>
        <!-- 标签数量： -->
        <div class="row">
          <div class="label">
            {{ $t("message.numberOfLabels") }}
            ：
          </div>
          <div class="val">
            <el-input v-model="datas.num" onfocus="this.select()" type="number"
              :placeholder="$t('message.numberOfLabels')"></el-input>
          </div>
        </div>
        <!-- 编码规则： -->
        <div class="row">
          <div class="label">
            {{ $t("message.codingRule") }}
            ：
          </div>
          <div class="val">
            <el-radio-group v-model="datas.code_type">
              <el-radio :label="'CODE128'" v-if="datas.type != 'ZOZO'">CODE128</el-radio>
              <el-radio :label="'EN13'" v-if="datas.type == 'LETIAN' || (deliveryDisplay && datas.type == '其他')">EN13</el-radio>
              <el-radio :label="'EN8'" v-if="deliveryDisplay && datas.type == '其他'">EN8</el-radio>
              <el-radio :label="'CODE39'" v-if="datas.type == 'LETIAN' || datas.type == 'ZOZO'">CODE39</el-radio>
            </el-radio-group>
          </div>
        </div>
        <!-- 标签商品管理编码： -->
        <div class="row" v-if="datas.type != 'ZOZO'">
          <div class="label">
            {{ goodsNoLabel }}
            ：
          </div>
          <div class="val">
            <input type="text" v-model="datas.goods_no" @paste="handlePaste" class="goods_no" onfocus="this.select()"
              placeholder="请输入ASIN码">
          </div>
        </div>
        <!-- 标签显示内容： -->
        <div class="row">
          <div class="label">
            {{ $t("message.labelDisplayContent") }}
            ：
          </div>
        </div>
        <div class="table" v-if="datas.type != 'ZOZO'">
          <ol>
            <!-- 显示顺序 -->
            <li>
              {{ $t("message.displaySequence") }}
            </li>
            <!-- 内容类别 -->
            <li>
              {{ $t("message.contentCategory") }}
            </li>
            <!-- 具体内容 -->
            <li class="flex15">
              {{ $t("message.specificContent") }}
            </li>
          </ol>
          <!-- 第一行 -->
          <ul>
            <!-- 显示顺序 -->
            <li>1行</li>
            <!-- 内容类别 -->
            <li>
              <div>
                标签编码 <img src="@/assets/icon/条形码.svg" alt=""
                  style="width: 25px; vertical-align: middle; margin-left: 5px;">
              </div>
            </li>
            <!-- 具体内容 -->
            <li class="flex15">
              <el-input v-model="datas.no" onfocus="this.select()" :type="deliveryDisplay ? 'textarea' : 'text'"></el-input>
            </li>
          </ul>
          <!-- 第二行 -->
          <ul>
            <!-- 显示顺序 -->
            <li>2行</li>
            <!-- 内容类别 -->
            <li>标签文本描述</li>
            <!-- 具体内容 -->
            <li class="flex15">
              <el-input v-model="datas.text_line_one" onfocus="this.select()" :type="deliveryDisplay ? 'textarea' : 'text'"></el-input>
            </li>
          </ul>
          <!-- FBA、STOCKCREW 与 RAKU 标签均需要显示第三行文本。 -->
          <ul v-if="datas.type == 'FBA' || datas.type == 'STOCKCREW' || datas.type == 'RAKU' || (deliveryDisplay && datas.type == 'LETIAN')">
            <!-- 显示顺序 -->
            <li>3行</li>
            <!-- 内容类别 -->
            <li>标签文本描述2</li>
            <!-- 具体内容 -->
            <li class="flex15">
              <el-input v-model="datas.text_line_two" onfocus="this.select()" :type="deliveryDisplay ? 'textarea' : 'text'"></el-input>
            </li>
          </ul>
          <!-- 第五行 -->
          <ul>
            <!-- 显示顺序 -->
            <li>4行</li>
            <!-- 内容类别 -->
            <li>标签文本描述3</li>
            <!-- 具体内容 -->
            <li class="flex15">
              <el-input v-model="datas.text_line_three" onfocus="this.select()" type="textarea"></el-input>
            </li>
          </ul>
          <!-- 第五行 -->
          <ul>
            <!-- 显示顺序 -->
            <li>5行</li>
            <!-- 内容类别 -->
            <li>标签文本描述4</li>
            <!-- 具体内容 -->
            <li class="flex15">
              <el-input v-model="datas.text_line_four" onfocus="this.select()" type="textarea"></el-input>
            </li>
          </ul>
        </div>
        <!-- 标签 ZOZO-->
        <div class="table" v-else>
          <ol>
            <!-- 显示顺序 -->
            <li>
              {{ $t("message.displaySequence") }}
            </li>
            <!-- 内容类别 -->
            <li>
              {{ $t("message.contentCategory") }}
            </li>
            <!-- 具体内容 -->
            <li class="flex15">
              {{ $t("message.specificContent") }}
            </li>
          </ol>
          <ul>
            <!-- 显示顺序 -->
            <li>1行</li>
            <!-- 内容类别 -->
            <li>ZOZO管理编码</li>
            <!-- 具体内容 -->
            <li class="flex15">
              <el-input v-model="datas.no" onfocus="this.select()" :type="deliveryDisplay ? 'textarea' : 'text'"></el-input>
            </li>
          </ul>
          <!-- 第一行 -->
          <ul>
            <!-- 显示顺序 -->
            <li>2行</li>
            <!-- 内容类别 -->
            <li>商品名</li>
            <!-- 具体内容 -->
            <li class="flex15">
              <el-input v-model="datas.text_line_one" onfocus="this.select()" :type="deliveryDisplay ? 'textarea' : 'text'"></el-input>
            </li>
          </ul>
          <!-- 第二行 -->
          <ul>
            <!-- 显示顺序 -->
            <li>3行</li>
            <!-- 内容类别 -->
            <li>zozo情报</li>
            <!-- 具体内容 -->
            <li class="flex15">
              <el-input v-model="datas.text_line_two" onfocus="this.select()" :type="deliveryDisplay ? 'textarea' : 'text'"></el-input>
            </li>
          </ul>
          <!-- 第三行 -->
          <ul>
            <!-- 显示顺序 -->
            <li>4行</li>
            <!-- 内容类别 -->
            <li>自社情報</li>
            <!-- 具体内容 -->
            <li class="flex15">
              <el-input v-model="datas.text_line_three" onfocus="this.select()" :type="deliveryDisplay ? 'textarea' : 'text'"></el-input>
            </li>
          </ul>
          <!-- 第四行 -->
          <ul>
            <!-- 显示顺序 -->
            <li>5行</li>
            <!-- 内容类别 -->
            <li>メーカー情報</li>
            <!-- 具体内容 -->
            <li class="flex15">
              <el-input v-model="datas.text_line_four" onfocus="this.select()"></el-input>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.save") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    tagData: { type: Object },
    saveHandler: { type: Function, default: null },
    goodsNoLabel: { type: String, default: 'ASIN' },
    deliveryDisplay: { type: Boolean, default: false },
  },
  data() {
    return {
      datas: {},
      dialogVisible: false,
      tagList: [],
    };
  },
  methods: {
    //切换type
    handleClick() {
      if (this.datas.type == 'FBA' || this.datas.type == 'YAHU' || this.datas.type == 'RAKU') {
        this.datas.code_type = 'CODE128'
      } else if (this.datas.type == 'ZOZO') {
        this.datas.code_type = 'CODE39'
      }
    },
    // 保存
    save() {
      this.datas.no = this.datas.no.trim()
      if (!this.datas.type || !this.datas.code_type) return this.$message.error('标签类别或者编码规则未选择，不能保存')
      const saveData = JSON.parse(JSON.stringify(this.datas))
      if (this.saveHandler) {
        return Promise.resolve(this.saveHandler(saveData)).then(() => {
          this.dialogVisible = false
        }).catch(() => {})
      }
      this.$parent.detail.order_detail[this.$parent.i].order_detail_tag = [this.datas]
      this.$forceUpdate()
      this.$parent.tagData = {}
      this.dialogVisible = false
    },
    // input粘贴事件
    handlePaste(e) {
      let list = e.clipboardData.getData('Text').split('\n')
      this.datas.no = list[1]
      this.datas.text_line_one = list[2]
      this.datas.text_line_two = list[3]
      this.datas.text_line_three = list[4]
      this.datas.text_line_four = list[5]
      setTimeout(() => {
        this.datas.goods_no = list[0]
        this.$forceUpdate()
      }, 500)
    },
    // 获取订单详情标签列表
    orderDetailTagList() {
      this.$api.clienteleApi.orderDetailTagList({}).then((res) => {
        this.tagList = res.data;
      })
    }

  },
  watch: {
    dialogVisible() {
      if (!this.dialogVisible) return
      this.orderDetailTagList()
      if (this.tagData != null) {
        this.datas = this.tagData;

      } else {
        this.datas = {

        }
      }
    },
  },
};
</script>
<style lang='scss' scoped>
/deep/.el-radio__input {
  transform: scale(1.5);
}

.content {
  margin: 0px 15px;

  .row {
    display: flex;
    margin-bottom: 20px;

    .label {
      flex: 1;
      line-height: 40px;
    }

    .val {
      flex: 3;
      line-height: 40px;
    }
  }

  .table {
    border: 1px solid #edeff4;

    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;

      &:nth-last-child(1) {
        border: 0;
      }

      li {
        padding: 5px 0;
      }
    }

    li {
      border-right: 1px solid #edeff4;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex15 {
      flex: 1.5;
    }
  }

  /deep/.el-input {
    width: 80%;
  }

  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }

  .goods_no {
    width: 400px;
    height: 38px;
    padding: 0 10px;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
  }
}

// 付款后订单仅复用配送单标签的展示控件与间距，保存逻辑仍使用订单接口。
.delivery-display {
  /deep/.el-textarea__inner {
    height: 50px !important;
  }

  .content .table ul li {
    padding: 5px;
  }
}
</style>
